export const isInRangeOfArray = (target: number, arr: number[]) => {
  let min = null;
  let max = null;
  if (arr.length === 0) {
    min = null;
    max = null;
  } else {
    min = arr[0];
    max = arr[0];
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] < min) {
        min = arr[i];
      } else if (arr[i] > max) {
        max = arr[i];
      }
    }
  }
  const rv = min !== null && max !== null && target >= min && target <= max;
  return rv;
};

interface NumberTuple {
  first: number;
  second: number;
}

interface ExplicitRange {
  min: number;
  max: number;
}

function isTuple(range: ExplicitRange | NumberTuple): range is NumberTuple {
  return (range as NumberTuple).first !== undefined;
}

export const isInRange = (
  target: number,
  range: ExplicitRange | NumberTuple
) => {
  let min, max;
  if (isTuple(range)) {
    min = range.first;
    max = range.second;
  } else {
    min = range.min;
    max = range.max;
  }
  return target >= min && target <= max;
};
